import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CartItemDetailsItems, getCartItemDetailsItemsList } from '@pedix-workspace/orders';
import { CartItem, SUPPORTED_LANGUAGES } from '@pedix-workspace/utils';

import { TranslocoDirective } from '@ngneat/transloco';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-cart-item-details',
    templateUrl: './cart-item-details.component.html',
    styleUrls: ['./cart-item-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective]
})
export class CartItemDetailsComponent {
  @Input() cartItem: CartItem;
  @Input() selectedLanguage: SUPPORTED_LANGUAGES;
  @Input() displaySku = false;

  get cartItemDetailsItems(): CartItemDetailsItems[] {
    return getCartItemDetailsItemsList(this.cartItem, {
      selectedLanguage: this.selectedLanguage,
      displaySku: this.displaySku,
    });
  }
}
